<template>
  <Compras></Compras>
</template>

<script setup>
  import Compras from "@/module/compras/Compras.vue";
  /* import { watchEffect, watch } from "vue";

  import { useMagicKeys } from "@vueuse/core";

  const { shift, space, n } = useMagicKeys();

  watch(space, (v) => {
    if (v) console.log("space has been pressed");
  });

  watchEffect(() => {
    if (shift.value && n.value) console.log("Shift + N have been pressed");
  }); */
</script>
